import styled, { css } from 'styled-components'
import { Variant } from './index'

interface IProps {
  variant?: Variant
  [key: string]: unknown
}

export const StyledContainer = styled.button<IProps>`
  position: relative;
  background-color: ${({ theme }) => theme.COLOR.PRIMARY_BLUE};
  font-family: ${({ theme }) => theme.FONT.PRIMARY};
  color: ${({ theme }) => theme.COLOR.PRIMARY_WHITE};
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  padding: 12px 24px;
  border: none;
  cursor: pointer;
  gap: 0.8rem;
  min-width: 150px;
  border-radius: 8px;
  text-decoration: none;
  transition: ${({ theme }) => theme.TRANSITION.TRANSITION_EASE_IN_OUT};

  &:hover {
    background-color: ${({ theme }) => theme.COLOR.PRIMARY_DARKBLUE_HOVER};
  }

  ${({ variant, theme }) =>
    variant === Variant.PRIMARY &&
    css`
      background-color: ${theme.COLOR.PRIMARY_RED};

      &:hover {
        background-color: ${({ theme }) => theme.COLOR.PRIMARY_RED_HOVER};
      }
    `}


  ${({ variant, theme }) =>
    variant === Variant.SECONDARY &&
    css`
    background: transparent;
      color: ${theme.COLOR.SECONDARY_GREY};

      &:hover {
        background: transparent;
      }
    `}
  
  ${({ isDisabled }) => isDisabled === true && css`
    background-color: ${({ theme }) => theme.COLOR.NEUTRAL_GREY_2};
    color: ${({ theme }) => theme.COLOR.NEUTRAL_GREY_3};
    pointer-events: none;
    border: none;
    
    &:after {
      border-left-color: ${({ theme }) => theme.COLOR.NEUTRAL_GREY_1};
    }
    
  `}
`

export const StyledBackIcon = styled.img`
margin-right: 5px;
`

export const StyledLoaderContainer = styled.div`
  display: inline-flex;
  margin-left: 1rem;
`
